import ConfirmationModal from "../ConfirmationModal";

import useAppStore from "../../../../states/zustand/appStore";

type Props = {
  callBack: () => void;
};

const SubmitConfirmationModal = (props: Props) => {
  const { callBack } = props;
  const {isSubmitModalVisible, setIsSubmitModalVisible} = useAppStore(
    (state) => state
  );

  const openConfirmationModal = () => {
    setIsSubmitModalVisible(true);
  };

  const closeConfirmationModal = () => {
    setIsSubmitModalVisible(false);
  };

  const confirmationHandler = async () => {
    callBack?.();
    setIsSubmitModalVisible(false);
  };
  return (
    <ConfirmationModal
      submitText={"Submit"}
      open={isSubmitModalVisible}
      onConfirm={confirmationHandler}
      onClose={closeConfirmationModal}
      description="Are you sure to Submit this?"
    />
  );
};

export default SubmitConfirmationModal;
